import React, { useEffect } from "react"
import Container from "./Container"
import footer_logo from "../images/footer/footer_logo.svg"
import location_logo from "../images/footer/location_logo.svg"
import phone_logo from "../images/footer/phone_logo.svg"
import instagram_logo from "../images/footer/instagram_logo.svg"
import facebook_logo from "../images/footer/facebook_logo.svg"
import twitter_logo from "../images/footer/twitter_logo.svg"
import linkedin_logo from "../images/footer/linkedin_logo.svg"
import Button from "./Button"

// import { Link, navigate } from "gatsby"

function Footer({ showContact }) {
  return (
    <div>
      {/* Contact us */}
      {showContact && (
        <div className="bg-[#F9F9F9] py-16 mb-[268px]">
          <Container>
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="w-full lg:w-[50%]">
                <p className="uppercase text-[22px] w-full mb-[36px] lg:text-[40px]  lg:w-full font-[700] leading-[25px] lg:leading-[42px]">
                  {" "}
                  DON'T WAIT - REQUEST YOUR FREE ROOFING QUOTE TODAY!
                </p>
                <p className="font-[400] text-[14px] lg:text-[16px] text-[#222222]">
                  Ready to get started? Contact us today for a free,
                  no-obligation estimate. Call us at{" "}
                  <span className="font-[700] text-[16px] lg:text-[20px]">
                    07956223569{" "}
                  </span>
                  email us at{" "}
                  <span className="font-[700] text-[16px] lg:text-[20px]">
                    info@propertyplusroofings.com
                  </span>
                  .
                </p>
              </div>
              {/* Form */}
              <div className="w-full lg:w-[50%] ">
                <form
                  id="email-form"
                  name="email-form"
                  data-name="Email Form"
                  method="post"
                  // action="https://2o60o2o7ze.execute-api.eu-west-2.amazonaws.com/prod"
                  // onSubmit={handleSubmit}
                >
                  <div className=" flex flex-col gap-6">
                    <div className="w-full mb-0 lg:mb-5  flex flex-col lg:flex-row  items-center justify-between gap-4">
                      <input
                        type="text"
                        placeholder="FIRST NAME"
                        maxLength="256"
                        // value={formData.firstName}
                        name="firstName"
                        // onChange={handleChange}
                        data-name="First Name"
                        id="First-Name"
                        required
                        className="quicksand border-b-[1px] border-black bg-transparent text-[14px] placeholder:text-[#000000] w-full lg:w-[50%]  py-[16px] "
                      />
                      <input
                        type="text"
                        placeholder="LAST NAME"
                        maxLength="256"
                        // value={formData.lastName}
                        // onChange={handleChange}
                        data-name="Last Name"
                        id="Last-Name"
                        name="lastName"
                        required
                        className="quicksand border-b-[1px] border-black bg-transparent text-[14px] placeholder:text-[#000000] w-full lg:w-[50%]  py-[16px] "
                      />
                    </div>
                    <input
                      type="email"
                      maxLength="256"
                      placeholder="EMAIL ADDRESS"
                      // value={formData.email}
                      // onChange={handleChange}
                      data-name="Email"
                      id="Email"
                      name="email"
                      required
                      className="quicksand border-b-[1px] border-black bg-transparent text-[14px] placeholder:text-[#000000] w-full  py-[16px] "
                    />
                    <select
                      id="options"
                      // value={selectedOption}
                      // onChange={handleChange}
                      className="quicksand border-b-[1px] border-black bg-transparent text-[14px] placeholder:text-[#000000] w-full  py-[25px] "
                    >
                      <option value="">SELECT ROOFING SERVICE</option>
                      <option value="option1">Option 1</option>
                      <option value="option2">Option 2</option>
                      <option value="option3">Option 3</option>
                    </select>{" "}
                    {/* <input
                    type="tel"
                    placeholder="Phone number"
                    // onChange={handleChange}
                    data-name="Phone"
                    id="Phone"
                    name="phone"
                    required
                    className="quicksand text-[14px] mb-5 w-full placeholder:text-[#666666] flex-1 px-[24px] py-[16px] rounded-[47px] bg-[#F7F7F7]"
                  />
                  <input
                    type="text"
                    placeholder="Business name"
                    maxLength="256"
                    // value={formData.businessName}
                    // onChange={handleChange}
                    data-name="Business name"
                    id="Business-name"
                    name="businessName"
                    required
                    className="quicksand text-[14px] mb-5 w-full placeholder:text-[#666666] flex-1 px-[24px] py-[16px] rounded-[47px] bg-[#F7F7F7]"
                  />
                  <input
                    type="text"
                    placeholder="Message title"
                    maxLength="256"
                    // value={formData.messageTitle}
                    // onChange={handleChange}
                    data-name="Message-title"
                    id="Message-title"
                    name="messageTitle"
                    required
                    className="quicksand text-[14px] mb-5 w-full placeholder:text-[#666666] flex-1 px-[24px] py-[16px] rounded-[47px] bg-[#F7F7F7]"
                  /> */}
                    <textarea
                      className="quicksand mb-[30px] border-b-[1px] border-black bg-transparent text-[14px] placeholder:text-[#000000] w-full  py-[16px] "
                      data-name="Message"
                      maxLength="5000"
                      id="Message"
                      name="message"
                      // value={formData.message}
                      // onChange={handleChange}
                      cols="20"
                      rows="5"
                      placeholder="MESSAGE"
                      required
                    ></textarea>
                    <div className="mx-auto w-[120px] ">
                      {/* <Button>Submit</Button> */}

                      {/* <button
                      type="submit"
                      disabled={loading}
                      className="py-4 w-full text-sm border px-8 rounded-full focus:outline-none hover:opacity-90  bg-primary text-white shadow-custom"
                    >
                      {loading ? "Sending" : "Submit"}
                    </button> */}
                      <Button text="SUBMIT" variant="filled" />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Container>
        </div>
      )}

      {/* Footer */}
      <div className="bg-[#1A1A1A] py-24 ">
        <Container>
          <div>
            <div className="flex flex-col lg:flex-row justify-between">
              <div className="mb-[50px] w-[100px] lg:w-[250px] ">
                <img className="w-full" src={footer_logo} alt="" />
              </div>
              <div className="text-[#D0DAF5]">
                <div className="flex gap-4 items-center mb-4">
                  <img className="w-[25px]" src={location_logo} alt="" />

                  <p className="text-[14px] font-[400]">
                    Plaza 535 King’s Road London SW10 0SZ
                  </p>
                </div>
                <div className="flex gap-4 mb-6 items-center">
                  <img className="w-[25px]" src={phone_logo} alt="" />

                  <p className="text-[14px] font-[400]">07956223569</p>
                </div>

                <div className="flex flex-col lg:flex-row gap-6 items-start lg:items-center">
                  <p className="opacity-50 font-[500]">Social Media</p>

                  <div className="flex items-center gap-6">
                    <img src={facebook_logo} alt="" />
                    <img src={twitter_logo} alt="" />
                    <img src={linkedin_logo} alt="" />
                    <img src={instagram_logo} alt="" />
                  </div>
                </div>
              </div>
            </div>
            <hr className="mb-[26px] border-t opacity-[0.2] mt-[80px] border-[#7BB9FC]" />

            <div className="flex flex-col lg:flex-row justify-between">
              <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
                <p className="text-[#D0DAF5]">ABOUT US</p>
                <p className="text-[#D0DAF5]">CONTACT US</p>
                <p className="text-[#D0DAF5]">PRIVACY POLICY</p>
              </div>
              <hr className="block lg:hidden mb-[26px] border-t opacity-[0.2] mt-[80px] border-[#7BB9FC]" />

              <div>
                <p className="text-[#D0DAF5] font-[400] opacity-[0.5] ">
                  Copyright © 2024 • ABC Company.
                </p>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default Footer
